import { USERS_SORT_BY_SET, USERS_SORT_ORDER_SET } from './actionTypes'

/**
 * Sets sort by
 * @param {string} column
 * @returns {Object} Action Object
 */
export const setSortBy = column => ({
  type: USERS_SORT_BY_SET,
  payload: column,
})

/**
 * Sets sort order
 * @param {string} order
 * @returns {Object} Action Object
 */
export const setSortOrder = order => ({
  type: USERS_SORT_ORDER_SET,
  payload: order,
})
